
































































import { Component, Mixins, Prop } from "vue-property-decorator";
import CProdInjectorMixin from "@/mixins/cProdInjectorMixin";
import CProdProvInjectorMixin from "@/mixins/cProdProvInjectorMixin";
import _ from "@/boot/lodash";

@Component({
  components: {
    "cprod-image": () =>
      import("@/components/app/global/contractProducts/cProdImage.vue")
  }
})
export default class CProdTabigation extends Mixins(
  CProdInjectorMixin,
  CProdProvInjectorMixin
) {
  // Props

  @Prop({ default: () => [] })
  public routes!: (vm: CProdTabigation & any) => any[];

  public isPinned = false;
  public isPinnedTarget: Element | null = null;
  public isPinnedObserver: IntersectionObserver | null = null;
  public isProcessing = false;

  // Computed

  public get cProdRoutes() {
    return this.routes({
      cProdData: this.cProdData
    });
  }

  public get showImage() {
    if (!this.cProdData.contractProduct) return false;
    return !!this.cProdData.images.length;
  }

  public get cProdEntity() {
    return _.upperFirst(
      this.cProdData.contractProduct?.product?.provision_blueprint
        ?.service_name || this.cProdData.category
    );
  }

  public get cProdIdentifier() {
    return (
      this.cProdData.contractProduct?.service_identifier || this.cProdData.name
    );
  }

  public get filteredFunctions() {
    return this.$_.filter(
      this.cProdProvData.cProdProvFunctions,
      ({ highlight }) => !!highlight
    );
  }

  // Methods

  public async process(action): Promise<any> {
    try {
      this.isProcessing = true;
      await action({
        $cProdMethods: this.$cProdMethods,
        $cProdProvMethods: this.$cProdProvMethods
      });
    } finally {
      this.isProcessing = false;
    }
  }

  public mounted() {
    this.isPinnedObserver = new IntersectionObserver(
      ([{ intersectionRatio }]) =>
        this.$set(this, "isPinned", intersectionRatio < 1),
      /* rootMargin = 72px (height of header) + 1px */
      { threshold: [1], rootMargin: "-73px 0px 0px 0px" }
    );
    this.isPinnedTarget = document.querySelector(
      ".u-cptabs-content"
    ) as Element;
    this.isPinnedObserver.observe(this.isPinnedTarget);
  }

  public beforeDestroy() {
    if (this.isPinnedObserver && this.isPinnedTarget)
      this.isPinnedObserver.unobserve(this.isPinnedTarget);
  }
}
